import { createElement } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Page404 from '../../pages/404';
import AsyncComponent from '../../components/AsyncComponent';
import LayoutController from './LayoutController';
import { RouteConfig } from '../../config/routerConfig';
import RouteList from './RouteList';
const AllPages = getAllPages();

const allLayouts = getAllLayouts();

const allWrappers = getAllWrappers();

function getAllPages() {
  const allPages: any = {};

  // @ts-ignore
  const normalContext = require.context('@/pages/', true, /^.+\/[A-Z]\w+\.[jt]sx?$/);
  const fileReg = /^.+\/([A-Z]\w+?)\.[jt]sx?$/;
  normalContext.keys().forEach((key: string) => {
    const name = key.replace(fileReg, '$1');
    if (name) {
      if (allPages[name]) {
        throw new Error(`Page ${name} has same name with other file: ${key}`);
      }
      allPages[name] = normalContext(key).default;
    }
  });

  // @ts-ignore
  const lazyContext = require.context('@/pages/', true, /^.+\/[A-Z]\w+\.lazy\.[jt]sx?$/, 'lazy');
  const lazyFileReg = /^.+\/([A-Z]\w+?)\.lazy\.[jt]sx$/;
  lazyContext.keys().forEach((key: string) => {
    const name = key.replace(lazyFileReg, '$1');
    if (name) {
      if (allPages[name]) {
        throw new Error(`Page ${name} has same name with other file: ${key}`);
      }
      allPages[name] = AsyncComponent(() => lazyContext(key));
    }
  });
  return allPages;
}

function getAllLayouts() {
  const allFile: any = {};

  // @ts-ignore
  const normalContext = require.context('@/layouts/', false, /^.+\/[A-Z]\w+\.[jt]sx?$/);
  const fileReg = /^.+\/([A-Z]\w+?)\.[jt]sx?$/;
  normalContext.keys().forEach((key: string) => {
    const name = key.replace(fileReg, '$1');
    if (name) {
      if (allFile[name]) {
        throw new Error(`Layouts ${name} has same name with other file: ${key}`);
      }
      allFile[name] = normalContext(key).default;
    }
  });
  return allFile;
}

function getAllWrappers() {
  const allFile: any = {};

  // @ts-ignore
  const normalContext = require.context('@/layouts/wrappers', true, /^.+\/[A-Z]\w+\.[jt]sx?$/);
  const fileReg = /^.+\/([A-Z]\w+?)\.[jt]sx?$/;
  normalContext.keys().forEach((key: string) => {
    const name = key.replace(fileReg, '$1');
    if (name) {
      if (allFile[name]) {
        throw new Error(`Layouts ${name} has same name with other file: ${key}`);
      }
      allFile[name] = normalContext(key).default;
    }
  });
  return allFile;
}

interface RouteRenderComponentProps extends RouteComponentProps<any> {
  layout?: string;
  children?: RouteConfig[];
  component?: string;
  wrappers?: string[];
  menu?: boolean;
  header?: boolean;
}

function RouteRenderComponent(props: RouteRenderComponentProps) {
  const { component, layout, menu, header, children, wrappers, ...restProps } = props;

  let Page = null;

  if (component) {
    Page = createElement(AllPages[component] || Page404, restProps);
    Page = createElement(LayoutController, { menu, header, ...restProps }, Page);
  }

  if (children) {
    Page = createElement(RouteList, { ...restProps, routeConfig: children });
  }

  if (layout) {
    Page = createElement(allLayouts[layout] || Page404, restProps, Page);
  }

  if (wrappers) {
    Page = wrappers.reduceRight((element, wrapper) => {
      const Wrapper = allWrappers[wrapper];
      return createElement(Wrapper, restProps, element);
    }, Page);
  }

  return Page;
}

RouteRenderComponent.defaultProps = {};

export default RouteRenderComponent;
